import { identityUrl } from "./config";
import { accessToken } from "./session";

/** The user's own account on the SSO (user-management), edited from inside TradeStorm. */
export interface IdentityProfile {
  id: string;
  email: string;
  name: string;
  phone: string | null;
  locale: string | null;
  timezone: string | null;
}
export interface IdentitySession {
  id: string;
  createdAt: string;
  expiresAt: string;
  ip: string | null;
  userAgent: string | null;
  /** The session this browser is signed in with. */
  current: boolean;
}
export interface IdentityPasskey {
  id: string;
  name: string | null;
  createdAt: string;
  lastUsedAt: string | null;
}

/** A call to the SSO's account API with this session's access token. Throws the server's own message. */
export async function identityApi<T>(method: "GET" | "POST" | "PATCH" | "DELETE", path: string, body?: unknown): Promise<T> {
  const token = await accessToken();
  const response = await fetch(`${identityUrl}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body === undefined ? {} : { "Content-Type": "application/json" }),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
    cache: "no-store",
    signal: AbortSignal.timeout(15000),
  });
  if (!response.ok) {
    const detail = await response.json().catch(() => null);
    throw new Error((detail && typeof detail.error === "string" && detail.error) || `Request failed (${response.status})`);
  }
  return response.status === 204 ? (undefined as T) : ((await response.json()) as T);
}
